import { createContext } from 'react';

import { RootInstance, TNullable } from '@/types';

export const RootStoreContext = createContext<TNullable<RootInstance>>(null);

export const { Provider: StoreProvider } = RootStoreContext;
